import { Component } from 'react';
import Loading from '../../../components/Loading';
import { withTranslation } from 'react-i18next';
import { setConfigsQuery } from '../../../queries/global';

class SearchBehavior extends Component {
    constructor(props) {
        super();
        this.updateInput = this.updateInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.activeDomain = props.domains?.find((item) => item.status);

        this.state = {
            questions: 'where,when,how,why,what',
            best_translation: 'Best,Top,Most',
        };
    }

    updateInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmit(e) {
        e.preventDefault();
        if (!this.activeDomain) {
            return this.props.handleNext();
        }

        const params = {
            domain_id: this.activeDomain?.pk,
            questions: this.state.questions,
            best_translation: this.state.best_translation,
        };

        this.setState({ isLoading: true });

        setConfigsQuery(params)
            .then((res) => res.json())
            .then(() => {
                this.props.handleNext();
            })
            .catch((err) =>
                this.setState({
                    message: err.message ?? 'Something went wrong.',
                    message_tags: 'error',
                }),
            )
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="padding-x-20">
                    <div className="onboarding-step-8">
                        {this.activeDomain ? (
                            <div>
                                <div className="onboarding-subheader">
                                    {t('onboarding.step_8.questions_info')}
                                </div>
                                <div className="row mr-10 align-items-start">
                                    <div className="col-3">{this.activeDomain?.url}</div>
                                    <div className="col-9 text-field">
                                        <input
                                            name="questions"
                                            className="form-control"
                                            onChange={this.updateInput}
                                            value={this.state.questions}
                                        />
                                    </div>
                                </div>
                                <div className="onboarding-subheader mt-20">
                                    {t('onboarding.step_8.best_info')}
                                </div>
                                <div className="row mr-10 align-items-start">
                                    <div className="col-3">{this.activeDomain?.url}</div>
                                    <div className="col-9 text-field">
                                        <input
                                            name="best_translation"
                                            className="form-control"
                                            onChange={this.updateInput}
                                            value={this.state.best_translation}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            'You need to activate the domain.'
                        )}
                        {this.state.message && (
                            <div className={`onboarding-message-${this.state.message_tags}`}>
                                {this.state.message}
                            </div>
                        )}
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer">
                    <button className="onboarding-skip-btn" onClick={() => this.props.handleBack()}>
                        {t('onboarding.back')}
                    </button>
                    <button
                        className="onboarding-btn-next"
                        onClick={this.onSubmit}
                        disabled={this.state.isLoading}
                    >
                        {this.activeDomain ? t('onboarding.save_and_next') : t('onboarding.next')}
                        {this.state.isLoading && <Loading onlyPreloader />}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(SearchBehavior);
